import React, { useCallback, useEffect, useMemo } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { PageLayout } from 'common/components';

import queryString from 'query-string';
import { getPartnershipClients, getPartnershipClientsBalance } from '../../_redux';
import { PartnershipClientsBlock } from '../../_components';

const PartnershipClientsPage = ({
  getPartnershipClientsBalance,
  getPartnershipClients,
  partnershipClients,
  location,
  history,
}) => {
  const query = useMemo(() => ({ page_size: 10, ...queryString.parse(location.search) }), [location.search]);
  const getList = useCallback(
    query => getPartnershipClients({ ...query, referType: 'refer_partner' }),
    [getPartnershipClients]
  );

  useEffect(() => {
    getList({ search: query });
  }, [getList, query]);

  return (
    <PageLayout captionSlug="partnershipClients">
      <div
        className={classNames({
          PartnershipUsersTable__inner: partnershipClients.count,
        })}>
        <PartnershipClientsBlock
          getPartnershipClientsBalance={getPartnershipClientsBalance}
          query={query}
          getList={getList}
          location={location}
          history={history}
        />
      </div>
    </PageLayout>
  );
};

PartnershipClientsPage.propTypes = {
  getPartnershipClientsBalance: PropTypes.func.isRequired,
  getPartnershipClients: PropTypes.func.isRequired,
  partnershipClients: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    partnershipClients: state.client.partnership.partnershipClients,
  }),
  {
    getPartnershipClientsBalance: () => getPartnershipClientsBalance.request(),
    getPartnershipClients: data => getPartnershipClients.request(data),
  }
)(PartnershipClientsPage);
export { PartnershipClientsPage };
